import { extractErrorMessage } from "@/core/api/errors";

export const getPayrollRosterApiErrorMessage = (error: unknown) => {
  const { message } = extractErrorMessage(error);
  return Array.isArray(message) ? message.join(". ") : String(message);
};
